module.exports = __webpack_public_path__ + "img/logo-blue.0bb860eb.svg";